import { render, staticRenderFns } from "./Role.vue?vue&type=template&id=bd51854e&scoped=true"
import script from "./Role.vue?vue&type=script&lang=js"
export * from "./Role.vue?vue&type=script&lang=js"
import style0 from "./Role.vue?vue&type=style&index=0&id=bd51854e&prod&scoped=true&lang=css"
import style1 from "./Role.vue?vue&type=style&index=1&id=bd51854e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd51854e",
  null
  
)

export default component.exports